import { queryOptions } from "@tanstack/react-query"
import { rolesService } from "@/services/roles/roles.service"

export const RoleQueryOptions = {
  all: queryOptions({
    queryKey: ["roles"],
    queryFn: async () => rolesService.getAll(),
  }),
}
